import { useState } from 'react'

import { Box, Button, Hidden, Paper, TablePagination } from '@material-ui/core'
import { PlusCircle as PlusCircleIcon } from 'react-feather'

import {
  Card,
  LoadingFeedback,
  OrganizationUsersForm,
  OrganizationUsersTable,
  Permitted,
} from 'components'

import { useFetch, usePagination } from 'hooks'
import * as service from 'service'
import permissions from 'constants/permissions'

const OrganizationUser = ({ organization }) => {
  const [openCreateDialog, setOpenCreateDialog] = useState(false)

  const handleOpenCreateDialog = () => setOpenCreateDialog(true)
  const handleCloseCreateDialog = () => setOpenCreateDialog(false)

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination()

  const {
    response: responseOrganizationUsers,
    isLoading: isLoadingOrganizationUsers,
    refresh: refreshOrganizationUsers,
  } = useFetch(
    service.backoffice.organizationUsers.all,
    {
      organizationId: organization?.id,
      params: { page, perPage },
    },
    [organization?.id, page, perPage],
    !!organization?.id,
  )

  const organizationUsers =
    responseOrganizationUsers?.data?.organizationUsers || []

  return (
    <Card
      title="Usuários"
      menuButton
      actionButton={
        <Permitted tag={permissions.ORGANIZATION_USER.MANAGE}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<PlusCircleIcon size={20} />}
            onClick={handleOpenCreateDialog}
          >
            CONVIDAR USUÁRIO
          </Button>
        </Permitted>
      }
    >
      <Paper component={Box}>
        <LoadingFeedback open={isLoadingOrganizationUsers} />
        <OrganizationUsersTable
          organizationUsers={organizationUsers}
          refresh={refreshOrganizationUsers}
          showUser
        />
        <TablePagination
          component="div"
          count={responseOrganizationUsers?.data?.meta?.totalCount || 0}
          onPageChange={(_, page) => handleChangePage(page)}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={perPage}
          rowsPerPageOptions={[5, 10, 25, 100]}
          labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
          nextIconButtonProps={{ size: 'small' }}
          backIconButtonProps={{ size: 'small' }}
        />

        {organization && (
          <OrganizationUsersForm
            open={openCreateDialog}
            setOpen={setOpenCreateDialog}
            onClose={handleCloseCreateDialog}
            organization={organization}
            refresh={refreshOrganizationUsers}
            isUserCreation={false}
          />
        )}
      </Paper>
    </Card>
  )
}

export default OrganizationUser
